module.exports = __webpack_public_path__ + "static/discord-ss-cf7e26e1cf059d3f7a5c131ff51630ba.png";